export default "__VITE_ASSET__37cfb88e__"